import React, { FC } from 'react';
import Modal from './common/Modal/Modal';

interface ModalAmountProps {
  isShow: boolean;
  amountValidation: string | null;
  onRequestClose: () => void;
}

const ModalAmount: FC<ModalAmountProps> = ({
  isShow,
  amountValidation,
  onRequestClose,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      onClose={onRequestClose}
      title="Check the amount"
      explanation={amountValidation}
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalAmount;
